import React, { type JSX } from 'react';
import { useTheme } from '@mui/material/styles';
import { AppBar, Button, CircularProgress, Stack, Toolbar } from '@mui/material';
import { CustomTransComponent } from 'components';
import { useNavigationBack } from 'hooks';
import { useLocation } from 'react-router-dom';

type CreateRealmOrgHeaderProps = {
    onSubmit?: () => void;
    isSubmitting?: boolean;
    isDisabled?: boolean;
};

export const CreateRealmOrgHeader = ({
    onSubmit,
    isSubmitting,
    isDisabled,
}: CreateRealmOrgHeaderProps): JSX.Element => {
    const theme: any = useTheme();

    const navigationBack = useNavigationBack();
    const { pathname } = useLocation();

    const handleCancel = (): void => {
        navigationBack();
    };
    const translationKey = pathname.includes('addOrg') ? 'COMMON:ADD_ORGANIZATION' : 'COMMON:ADD_REALM';
    return (
        <>
            <AppBar position={'static'}>
                <Toolbar className="bg-white text-black padding-5">
                    <Stack className="w-100">
                        <Stack
                            direction="row"
                            spacing={1}
                            alignItems={'center'}
                            justifyContent={'space-between'}
                            marginRight={2}
                        >
                            <Stack direction={'row'} justifyContent={'flex-end'} spacing={1} width={'100%'}>
                                <Button
                                    id="discard"
                                    disabled={false}
                                    sx={{
                                        border: `1px solid #e0e0e0`,
                                        '&:hover': {
                                            backgroundColor: theme?.palette?.primary?.[50],
                                            border: `1px solid`,
                                        },
                                    }}
                                    variant="outlined"
                                    onClick={handleCancel}
                                >
                                    <CustomTransComponent translationKey={'COMMON:CANCEL'} />
                                </Button>
                                <Button
                                    id="submit"
                                    disabled={isDisabled || isSubmitting}
                                    sx={{
                                        backgroundColor: theme?.palette?.primary?.main,
                                        '&:hover': {
                                            backgroundColor: theme?.palette?.primary?.main,
                                        },
                                    }}
                                    variant="contained"
                                    onClick={onSubmit}
                                >
                                    {isSubmitting ? (
                                        <Stack width={120} flexDirection={'row'} justifyContent={'space-evenly'}>
                                            <CircularProgress color="inherit" size={20} />
                                            <CustomTransComponent translationKey={'COMMON:SAVING'} />
                                        </Stack>
                                    ) : (
                                        <CustomTransComponent translationKey={translationKey} />
                                    )}
                                </Button>
                            </Stack>
                        </Stack>
                    </Stack>
                </Toolbar>
            </AppBar>
        </>
    );
};
